module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescir1-032b517fd7f9239d6396932cfb30dba4.jpg";